/**
 * STATISTICS (match statistics) interfaces and types
 */

export type StatisticsId =
  | 'possession_percentage'
  | 'on_target_scoring_att'
  | 'total_scoring_att'
  | 'total_post'
  | 'total_offside'
  | 'fouls'
  | 'total_yel_card'
  | 'total_red_card'
  | 'won_corners';

export const StatisticsIdList: StatisticsId[] = [
  'possession_percentage',
  'on_target_scoring_att',
  'total_scoring_att',
  'total_post',
  'total_offside',
  'fouls',
  'total_yel_card',
  'total_red_card',
  'won_corners',
];

export const StatisticsPercentageList: StatisticsId[] = ['possession_percentage'];

export const hasPercentage = (statistic: StatisticsId): boolean => {
  return StatisticsPercentageList.includes(statistic);
};
